import { jsx as _jsx } from "react/jsx-runtime";
import { NavigationDividerElement } from './styles/navigation-divider.styled';
export const NavigationDivider = () => {
    return _jsx(NavigationDividerElement, {});
};
